import reviewsEs from './es/reviews.json';
import reviewsEn from './en/reviews.json';

export const codReviewsEs = reviewsEs;
export const codReviewsEn = reviewsEn;
